/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_Login_ActionInputs */

const en_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login here.`)
};

const de_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier anmelden.`)
};

const pt_br2_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre aqui.`)
};

const tr_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buradan giriş yapın.`)
};

const zh_cn2_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此登录。`)
};

const zh_hk2_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此登入。`)
};

const ko_kr2_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기에서 로그인하세요.`)
};

const ru_ru2_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите здесь.`)
};

const es_419_onboarding_v1_username_login_action = /** @type {(inputs: Onboarding_V1_Username_Login_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión aquí.`)
};

/**
* | output |
* | --- |
* | "Login here." |
*
* @param {Onboarding_V1_Username_Login_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_login_action = /** @type {((inputs?: Onboarding_V1_Username_Login_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_Login_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_login_action(inputs)
	if (locale === "de") return de_onboarding_v1_username_login_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_login_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_login_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_login_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_login_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_login_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_login_action(inputs)
	return es_419_onboarding_v1_username_login_action(inputs)
});